/* eslint-disable-next-line */
export interface ModulesProductComponentsProps {}

export function ModulesProductComponents(props: ModulesProductComponentsProps) {
  return (
    <div>
      <h1>Welcome to ModulesProductComponents!</h1>
    </div>
  );
}

export default ModulesProductComponents;
